module.exports = __webpack_public_path__ + "static/fonts/Fact-NarrowBlack.b06d85a.eot";